/* eslint-disable no-useless-escape */
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Radio, Row, Col, List, Badge } from 'antd';
import { connect } from 'react-redux';
import * as actions from 'actions';
var nlp = require('compromise');

const mapStateToProps = state => ({
	lqInfosText: state.info.lqInfosText,
});

const mapDispatchToProps = dispatch => ({
	onSearchDeco: highlights => dispatch(actions.onSearchDeco(highlights)),
});

const styles = {
	scrollContainer: {
		border: '1px solid rgb(243, 171, 40)',
		borderRadius: '4px',
		overflow: 'auto',
		padding: '8px 10px',
		margin: '10px',
		height: '300px',
	},
	antListItem: {
		display: 'flex',
		alignItems: 'center',
		padding: '0px',
	},
	badge: {
		backgroundColor: 'rgb(243, 171, 40)',
		color: '#fff',
		boxShadow: '0 0 0 1px #f79f00 inset',
	},
};

class DistinctInfo extends Component {
	state = {
		eojel: '1',
		data: [],
		t1: 0,
		t2: 0,
		t3: 0,
	};

	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			text: props.lqInfosText,
			selectedKey: props.selectedKey,
		};
	}

	componentDidMount() {
		const _text = this.state.text != null && this.state.text.replace(/,/g, '#q#');
		var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
		const t = nlp(_text)
			.ngrams({ max: 3 })
			.data()
			.filter(i => i.count > 1 && !regExp.test(i.normal))
			.map(i => {
				return { ...i, normal: i.normal.replace(/#q#/g, ',') };
			});

		const _t = t.filter(i => i.size === parseInt(this.state.eojel));
		const _t1 = t.filter(i => i.size === 1);
		const _t2 = t.filter(i => i.size === 2);
		const _t3 = t.filter(i => i.size === 3);
		this.setState({ datas: t, filterData: _t, t1: _t1.length, t2: _t2.length, t3: _t3.length });
	}

	onChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};

	componentWillReceiveProps(nextProps) {
		const { lqInfosText, selectedKey } = nextProps;
		this.setState({ text: lqInfosText, selectedKey });
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.text !== prevState.text) {
			const _text = this.state.text != null && this.state.text.replace(/,/g, '#q#');
			const t = nlp(_text)
				.ngrams({ max: 3 })
				.data()
				.filter(i => i.count > 1)
				.map(i => {
					return { ...i, normal: i.normal.replace(/#q#/g, ',') };
				});

			const _t = t.filter(i => i.size === parseInt(this.state.eojel));

			const _t1 = t.filter(i => i.size === 1);
			const _t2 = t.filter(i => i.size === 2);
			const _t3 = t.filter(i => i.size === 3);
			this.setState({ datas: t, filterData: _t, t1: _t1.length, t2: _t2.length, t3: _t3.length });
		}
		if (this.state.eojel !== prevState.eojel) {
			if (this.state.datas != null) {
				const _t = this.state.datas.filter(i => i.size === parseInt(this.state.eojel));
				this.setState({ filterData: _t });
			}
		}
		if (this.state.selectedKey !== prevState.selectedKey) {
			if (this.state.selectedKey !== '3') {
				this.props.onSearchDeco([]);
			}
		}
	}

	onClick = (e, search) => {
		const searchs = [];
		searchs.push(search);
		this.props.onSearchDeco(searchs);
	};

	render() {
		const { t1, t2, t3 } = this.state;
		return (
			<Fragment>
				<div
					style={{
						padding: '8px 10px',
						margin: '0',
						background: '#fff',
					}}
				>
					<Row>
						<Col style={{ textAlign: 'center' }}>
							<Radio.Group
								name="eojel"
								value={this.state.eojel}
								onChange={this.onChange}
								style={{ marginTop: '10px' }}
							>
								<Badge count={t1} showZero style={{ backgroundColor: 'rgb(243, 171, 40)' }}>
									<Radio.Button value="1" className="head-example">
										1어절
									</Radio.Button>
								</Badge>
								<Badge count={t2} showZero style={{ backgroundColor: 'rgb(243, 171, 40)' }}>
									<Radio.Button value="2" className="head-example">
										2어절
									</Radio.Button>
								</Badge>
								<Badge count={t3} showZero style={{ backgroundColor: 'rgb(243, 171, 40)' }}>
									<Radio.Button value="3" className="head-example">
										3어절
									</Radio.Button>
								</Badge>
							</Radio.Group>
						</Col>
					</Row>
					<Row>
						<Col>
							<div style={styles.scrollContainer}>
								<List
									dataSource={this.state.filterData}
									renderItem={item => (
										<List.Item key={item.normal} style={styles.antListItem}>
											<List.Item.Meta
												title={
													<Link to="#" onClick={e => this.onClick(e, item.normal)}>
														{item.normal}
													</Link>
												}
											/>
											<Badge count={item.count} style={styles.badge} />
										</List.Item>
									)}
								/>
							</div>
						</Col>
					</Row>
				</div>
			</Fragment>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DistinctInfo);
